var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({ref:"text",class:[
    'tooltip',
    _vm.isClamped ? 'tooltip--clamped' : '',
    _vm.isClamped ? ("tooltip--clamped-" + _vm.rowCount) : '',
    { 'tooltip--expanded': _vm.isExpanded } ],attrs:{"title":_vm.isClamped ? _vm.text : ''},on:{"click":_vm.onTooltipClick}},'div',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/shared/ui/lk/Tooltip.vue?vue&type=template&id=6eafc0e0&
// module id = 1475
// module chunks = 0